import React from 'react';
import {gql, useQuery} from "@apollo/client/index";

const GET_TRIM = gql`
  query($models:[String]) {
        getTrim(models:$models) {
            make
            model
            value
            label
        }
  }
`;
export default function TrimRequest(props) {

    const { error, data } = useQuery(GET_TRIM, {variables: {
            models: props.makeModels
        }
    });

    if (error) {
        props.onError(error);
    }

    if (data) {
        props.onData(data.getTrim);
    }

    return null;
}
